import type React from 'react';

export const cn = (...classes: (string | undefined | null | false)[]): string =>
    classes.filter(Boolean).join(' ');

export const TOOLBAR_BUTTON_CLASS =
    'w-7 h-7 flex items-center justify-center rounded hover:bg-white/20 transition-colors';

export const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation();
};

const MIN_ZOOM = 0.5;
const MAX_ZOOM = 3.5;
export const ZOOM_STEP = 0.25;
export const WHEEL_ZOOM_STEP = 0.1;

export const clampZoom = (value: number): number => {
    return Number(Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, value)).toFixed(2));
};

// Lets a lone carousel keep answering arrow keys without an explicit focus.
export const mountedCarousels = new Set<HTMLDivElement>();

export const isTypingTarget = (el: Element | null): boolean => {
    if (!(el instanceof HTMLElement)) return false;
    return (
        el.isContentEditable ||
        el.tagName === 'INPUT' ||
        el.tagName === 'TEXTAREA' ||
        el.tagName === 'SELECT'
    );
};

export interface Point {
    x: number;
    y: number;
}

export interface ContainerSize {
    width: number;
    height: number;
}

export interface ZoomPanView {
    zoom: number;
    offset: Point;
    isPanning: boolean;
    zoomIn: () => void;
    zoomOut: () => void;
    resetView: () => void;
    handlers: {
        onMouseDown: (e: React.MouseEvent) => void;
        onMouseMove: (e: React.MouseEvent) => void;
        onMouseUp: () => void;
        onMouseLeave: () => void;
        onWheel: (e: React.WheelEvent) => void;
        onDoubleClick: () => void;
    };
}

export interface CarouselState {
    safeIndex: number;
    setIndex: (index: number) => void;
    isFullscreen: boolean;
    toggleFullscreen: () => void;
    showThumbnails: boolean;
    toggleThumbnails: () => void;
    goPrev: () => void;
    goNext: () => void;
    hasMultiple: boolean;
}
